var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPaymentVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 24.348 16",
    width: 24.348,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-21.608a1.4 1.4 0 0 1 1.4-1.392h21.551a1.4 1.4 0 0 1 1.4 1.392v13.216a1.4 1.4 0 0 1 -1.4 1.392h-21.551a1.4 1.4 0 0 1 -1.4-1.392z",
    transform: "translate(0 23)"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h31.304v22.957h-31.304z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-7h24.348v-16h-24.348z",
    transform: "translate(0 23)"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.794-15.174 1.418 5.354h1.649l2.562-6.2h-1.67l-1.613 4.208-.665-3.295-1.681-.068z",
    transform: "translate(-5.794 16.022)"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.355-16.056-.984 6.226h1.554l1.008-6.226z",
    transform: "translate(-13.371 16.056)"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.661-14.606.228-1.3a4.521 4.521 0 0 0 -1.51-.275c-.824 0-2.609.526-2.609 2.06s2.219 1.6 2.219 2.45-1.992.756-2.585.207l-.251 1.35a5.571 5.571 0 0 0 1.693.343c.8 0 2.792-.183 2.792-2.175 0-1.74-2.219-1.4-2.219-2.45 0 0 .228-1.055 2.243-.207z",
    transform: "translate(-17.152 16.184)"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.468-9.8h1.717l.3-.892h2.105l.174.883h1.489l-1.368-6.146h-1.374a.97.97 0 0 0 -.733.665c-.216.573-2.311 5.49-2.311 5.49z",
    transform: "translate(-23.468 15.954)"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.418-11.234h-1.395l.869-2.287z",
    transform: "translate(-27.023 13.521)"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.223-12.675-.491-2.435s-.065-.913-.718-.913h-2.658v.127a5.573 5.573 0 0 1 3.868 3.221z",
    transform: "translate(-3.356 16.022)"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-4h24.336v2.783h-24.336z",
    transform: "translate(0 4)"
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-23h24.336v2.783h-24.336z",
    transform: "translate(0 23)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "translate(-3.478 -3.478)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(3.478 3.478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-5-28h31.3v22.957h-31.3z",
    fill: "#fff",
    transform: "translate(1.522 24.522)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    transform: "translate(7.509 8.332)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(-4.03 -4.854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.794-21.022h12.585v13.158h-12.585z",
    fill: "#1a1e71",
    transform: "translate(-.242 22.398)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "translate(12.78 8.309)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(-9.302 -4.83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.371-21.056h9.519v13.182h-9.519z",
    fill: "#1a1e71",
    transform: "translate(-2.548 22.408)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "translate(15.41 8.22)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(-11.932 -4.742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.152-21.184h11.693v13.366h-11.693z",
    fill: "#1a1e71",
    transform: "translate(-3.698 22.447)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "translate(19.804 8.379)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(-16.325 -4.901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.468-20.954h12.742v13.111h-12.742z",
    fill: "#1a1e71",
    transform: "translate(-5.621 22.377)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "translate(22.277 10.073)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(-18.799 -6.594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.023-18.521h8.351v9.244h-8.351z",
    fill: "#fff",
    transform: "translate(-6.703 21.637)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "translate(5.813 8.332)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(-2.334 -4.854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.644-21.022h10.824v10.3h-10.824z",
    fill: "#1a1e71",
    transform: "translate(.5 22.398)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    transform: "translate(3.478 16.696)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(0 -13.217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-5-9h31.293v9.739h-31.293z",
    fill: "#f7b600",
    transform: "translate(1.522 18.739)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "translate(3.478 3.478)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-5-28h31.293v9.739h-31.293z",
    fill: "#1a1e71",
    transform: "translate(1.522 24.522)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPaymentVisa);
export default __webpack_public_path__ + "static/media/logo-payment-visa.1389036b.svg";
export { ForwardRef as ReactComponent };